import * as React from "react";
import {
  GridColumnMenuFilter,
  GridColumnMenuFilterUIProps,
  GridColumnMenuProps,
} from "@progress/kendo-react-grid";
import { CustomFilterUiRadioButton } from "./CustomFilterUiRadioButton";

export function YesNoColumnMenu(props: GridColumnMenuProps) {
  const filterUi = (filterUiProps: GridColumnMenuFilterUIProps) => (
    <CustomFilterUiRadioButton
      {...filterUiProps}
      values={[
        {
          label: "Yes",
          value: true,
        },
        {
          label: "No",
          value: false,
        },
      ]}
    />
  );

  return (
    <div>
      <GridColumnMenuFilter {...props} expanded filterUI={filterUi} />
    </div>
  );
}
